const Countries = [
  { code: 'IN', label: 'India' },
];

export default Countries;